import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/central_admissions.png";
import projImg2 from "../assets/img/expense_trackings.png";
import projImg3 from "../assets/img/data_visualization.png";
import projImg4 from "../assets/img/game_project.png";
import projImg5 from "../assets/img/ecommerce_project.png";
import projImg6 from "../assets/img/api_development.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "RP Admission",
      description: "Design & Coding",
      imgUrl: projImg1,
    },
    {
      title: "Expense Tracking",
      description: "Design & Development",
      imgUrl: projImg2,
    },
    {
      title: "Data Visualization Tool", 
      description: "Design & Development",
      imgUrl: projImg3,
    },
    {
      title: "Game Project",
      description: "Design & Development",
      imgUrl: projImg4,
    },
    {
      title: "Ecommerce Platform",
      description: "Design & Development",
      imgUrl: projImg5,
    },
    {
      title: "API Development",
      description: "Design & Development",
      imgUrl: projImg6,
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>Some of the projects are:</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Projects 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Projects 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Projects 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      <p>More projects coming soon.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>More projects coming soon.</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="" />
    </section>
  )
}
